// authReducer.js — DealCouponz-style auth slice
import * as authTypes from "../types/authTypes";

const initialState = {
  token: null,
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case authTypes.LOGIN_REQUEST:
    case authTypes.REGISTER_REQUEST:
    case authTypes.RESTORE_REQUEST:
      return { ...state, loading: true, error: null };

    case authTypes.LOGIN_SUCCESS:
    case authTypes.REGISTER_SUCCESS:
    case authTypes.RESTORE_SUCCESS: {
      const { token, user } = action.payload;
      return {
        ...state,
        loading: false,
        error: null,
        token,
        user,
        isAuthenticated: true,
      };
    }

    case authTypes.LOGIN_FAILURE:
    case authTypes.REGISTER_FAILURE:
    case authTypes.RESTORE_FAILURE:
      return {
        ...initialState,
        loading: false,
        error: action.payload != null ? action.payload : null,
      };

    case authTypes.LOGOUT:
      return { ...initialState };

    default:
      return state;
  }
}
